import React, { useState } from "react";
import { styles as ui } from "stories/Admin";
import styles from "./ImageDrop.module.scss";

interface ImageDropProps {
  label: string;
  required?: boolean;
  /** Image shown in the thumbnail (object URL or saved image). */
  preview: string | null;
  inputRef?: React.Ref<HTMLInputElement>;
  name?: string;
  help?: React.ReactNode;
  /** Called with the picked or dropped file (null when cleared). */
  onFile: (file: File | null) => void;
}

/** File input styled as the design's drop zone («Dra et bilde hit»). */
const ImageDrop: React.FC<ImageDropProps> = ({
  label,
  required,
  preview,
  inputRef,
  name = "plakat",
  help = "JPG eller PNG. Forhåndsvises før lagring.",
  onFile,
}) => {
  const [over, setOver] = useState(false);
  return (
    <div className={ui.fld}>
      <span className={ui.lbl}>
        {label}
        {required && <span className={ui.req}> *</span>}
      </span>
      <label
        className={`${styles.drop} ${over ? styles.dropOver : ""}`}
        onDragOver={(e) => {
          e.preventDefault();
          setOver(true);
        }}
        onDragLeave={() => setOver(false)}
        onDrop={(e) => {
          e.preventDefault();
          setOver(false);
          const file = e.dataTransfer.files?.[0];
          if (file && file.type.startsWith("image/")) onFile(file);
        }}
      >
        <input
          name={name}
          type="file"
          accept="image/*"
          className={styles.fileInput}
          ref={inputRef}
          onChange={(event) => onFile(event.currentTarget.files?.[0] || null)}
        />
        <span className={styles.thumb}>
          {preview ? (
            <img src={preview} alt="Forhåndsvisning" />
          ) : (
            <svg
              className={ui.icon}
              viewBox="0 0 24 24"
              width={22}
              height={22}
              strokeWidth={1.8}
              aria-hidden="true"
            >
              <path d="M4 4h16v16H4zM4 16l5-5 4 4 3-3 4 4M15 8.5a1.5 1.5 0 1 1 0 .01" />
            </svg>
          )}
        </span>
        <span className={styles.text}>
          <b>
            Dra et bilde hit eller <span className={styles.link}>velg fil</span>
          </b>
          <span className={styles.help}>{help}</span>
        </span>
      </label>
    </div>
  );
};

export default ImageDrop;
